// extracted by mini-css-extract-plugin
module.exports =  {"containerSlider":"containerSlider___OqmVZ","line":"line___SfH8Y","logoWrapper":"logoWrapper___xPpRn"};